import React from 'react';
import { motion } from 'framer-motion';
import { Minus } from 'lucide-react';
import type { PainContent } from '../../types/salesPage';
interface PainSectionProps {
  content: PainContent;
}
export function PainSection({
  content
}: PainSectionProps) {
  return <section aria-labelledby="pain-title" className="border-t border-white/[0.07] bg-ink px-5 py-14 sm:px-6 md:py-20" data-id="element-205" data-mp="3r1jzrobil2r1">
      <div className="mx-auto grid max-w-5xl items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-206" data-mp="njjpu3meenas">
        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-70px'
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="order-2 lg:order-1" data-id="element-207" data-mp="ijnjhxq8ajs2">
          <div className="overflow-hidden rounded-sm border border-white/10" data-id="element-208" data-mp="16982ggmdth1c">
            <img src={content.image.src} alt={content.image.alt} loading="lazy" decoding="async" className="h-56 w-full object-cover sm:h-72 lg:h-[380px]" data-id="element-209" data-mp="16bcghrdzvwfc" />
          </div>
        </motion.figure>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-70px'
      }} transition={{
        duration: 0.55,
        delay: 0.08,
        ease: 'easeOut'
      }} className="order-1 lg:order-2" data-id="element-210" data-mp="3gbswfngenlbk">
          <p className="font-mono text-[9.5px] uppercase tracking-[0.22em] text-gold md:text-[10px]" data-id="element-211" data-mp="2slyptnmoiszr">
            {content.eyebrow}
          </p>
          <h2 id="pain-title" className="mt-3 font-serif text-[24px] font-bold leading-tight text-parchment sm:text-[30px] md:text-[36px]" data-id="element-212" data-mp="2iok87kp0ry5v">
            {content.title}
          </h2>

          <ul className="mt-6 space-y-3" data-id="element-213" data-mp="gwpc4df8y28r">
            {content.losses.map(loss => <li key={loss} className="flex gap-3 border-l-2 border-[#A6453E]/60 bg-white/[0.02] py-2.5 pl-4 text-[14.5px] font-light leading-relaxed text-smoke" data-id="element-214" data-mp="lw1xsuudt39r">
                <Minus aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-[#C65C53]" data-id="element-215" data-mp="ffiiszeu2xu0" />
                {loss}
              </li>)}
          </ul>

          {content.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 text-[14.5px] font-light leading-[1.75] text-ash md:text-[15.5px]" data-id="element-216" data-mp="5ixeyhejvsrr">
              {paragraph}
            </p>)}

          <p className="mt-6 border-y border-gold/25 py-4 font-serif text-[17.5px] font-semibold leading-snug text-gold-soft md:text-[21px]" data-id="element-217" data-mp="y7ukrl1krx3m">
            {content.verdict}
          </p>
        </motion.div>
      </div>
    </section>;
}